<template>
    <div
        :class="[
            'relative inline-flex items-center justify-center flex-shrink-0 overflow-hidden select-none bg-theme-primary',
            sizeClass,
            circle ? 'rounded-full' : 'rounded-lg',
            pointer ? 'cursor-pointer' : ''
        ]"
    >
        <slot></slot>
        <span
            v-if="badge"
            :class="[
                'absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full border-2 border-theme-card',
                badgeColorClass
            ]"
        ></span>
    </div>
</template>

<script>
export default {
    name: "CustomAvatar",
    props: {
        size: { type: String, default: null },
        circle: { type: Boolean, default: false },
        pointer: { type: Boolean, default: false },
        badge: { type: Boolean, default: false },
        badgeColor: { type: String, default: "primary" }
    },
    computed: {
        sizeClass() {
            const sizes = {
                xlarge: "w-14 h-14",
                large: "w-10 h-10",
                small: "w-6 h-6"
            };
            return sizes[this.size] || "w-8 h-8";
        },
        badgeColorClass() {
            const colorMap = {
                primary: "bg-theme-primary",
                success: "bg-theme-success",
                danger: "bg-theme-danger",
                warn: "bg-theme-warning",
                warning: "bg-theme-warning",
                info: "bg-theme-info"
            };
            return colorMap[this.badgeColor] || "bg-theme-primary";
        }
    }
};
</script>
